import Joi from 'joi';

const EmailTemplate = Joi.object({
	subject: Joi.string().label('Subject').trim().min(1).max(250).required(),
	message: Joi.string().label('Message').trim().min(1).max(1000).required(),
}).unknown(true);

export default EmailTemplate;
